import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dialogs-component", {
    ref: _vm.DIALOG_EDIT_SCRIPT,
    attrs: {
      title: _vm.$t("create_attribute.dialogs.edit_script"),
      "show-buttons": true,
      "show-cancel-button": true,
      width: 800,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.item
              ? _c(
                  "div",
                  [
                    _vm.item.estado === 12
                      ? _c(
                          VAlert,
                          {
                            staticClass: "mb-4",
                            attrs: { type: "warning", outlined: "", dense: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.edit_script.warn_in_progress"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "info-section mb-4" },
                      [
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "create_attribute.edit_script.current_info"
                              )
                            )
                          ),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(VCol, { attrs: { cols: "12", md: "6" } }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.edit_script.use_case"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "info-value" }, [
                                _vm._v(_vm._s(_vm.item.caso_de_uso || "-")),
                              ]),
                            ]),
                            _c(VCol, { attrs: { cols: "12", md: "6" } }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.edit_script.table_name"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "info-value" }, [
                                _vm._v(_vm._s(_vm.item.nombre_tabla || "-")),
                              ]),
                            ]),
                            _c(VCol, { attrs: { cols: "12", md: "6" } }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.edit_script.current_version"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "info-value" }, [
                                _vm._v("v" + _vm._s(_vm.currentVersion)),
                              ]),
                            ]),
                            _c(VCol, { attrs: { cols: "12", md: "6" } }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.edit_script.current_filename"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "info-value" }, [
                                _vm._v(_vm._s(_vm.currentFilename)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VForm,
                      {
                        ref: "form",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.valid,
                          callback: function ($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-section" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.edit_script.new_script"
                                  )
                                )
                              ),
                            ]),
                            _c(
                              VCard,
                              {
                                staticClass: "card-bulk pa-4",
                                attrs: { outlined: "" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      dragover: function ($event) {
                                        $event.preventDefault()
                                      },
                                      drop: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "drag-file text-center pointer",
                                        class: {
                                          "drag-active": _vm.isDragging,
                                        },
                                        on: {
                                          drop: _vm.dropFile,
                                          dragenter: function ($event) {
                                            _vm.isDragging = true
                                          },
                                          dragleave: function ($event) {
                                            _vm.isDragging = false
                                          },
                                        },
                                      },
                                      [
                                        !_vm.form.script_file
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column align-center pt-3",
                                              },
                                              [
                                                _c(VImg, {
                                                  attrs: {
                                                    width: "56px",
                                                    src: require("@/assets/sql_icon.png"),
                                                  },
                                                }),
                                                _c(
                                                  "p",
                                                  { staticClass: "mt-2 mb-0" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "create_attribute.form.drag_file"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(VFileInput, {
                                          staticClass:
                                            "upload-input-file pointer",
                                          attrs: {
                                            accept: ".sql",
                                            chips: "",
                                            placeholder: _vm.$t(
                                              "create_attribute.form.attach_file"
                                            ),
                                            "prepend-icon": "",
                                            "show-size": "",
                                            "truncate-length": "50",
                                            solo: "",
                                            flat: "",
                                            rules: _vm.rules.file,
                                          },
                                          on: { change: _vm.onFileSelected },
                                          model: {
                                            value: _vm.form.script_file,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "script_file",
                                                $$v
                                              )
                                            },
                                            expression: "form.script_file",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm.parseErrors.length > 0
                              ? _c(
                                  VAlert,
                                  {
                                    staticClass: "mt-3 mb-0",
                                    attrs: {
                                      type: "error",
                                      outlined: "",
                                      dense: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-bold mb-1" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.edit_script.parse_errors_title"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "ul",
                                      { staticClass: "mb-0" },
                                      _vm._l(
                                        _vm.parseErrors,
                                        function (err, i) {
                                          return _c("li", { key: i }, [
                                            _vm._v(_vm._s(err)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.partitionValidation
                              ? _c("partition-validation-errors", {
                                  staticClass: "mt-3",
                                  attrs: {
                                    validation: _vm.partitionValidation,
                                  },
                                })
                              : _vm._e(),
                            _vm.form.script_file &&
                            _vm.parseErrors.length === 0 &&
                            !_vm.partitionValidation
                              ? _c(
                                  VAlert,
                                  {
                                    staticClass: "mt-3 mb-0",
                                    attrs: {
                                      type: "info",
                                      outlined: "",
                                      dense: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "create_attribute.edit_script.retrigger_info"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "btnsRight",
        fn: function () {
          return [
            _c(
              VBtn,
              {
                attrs: { color: "primary", disabled: !_vm.canSubmit },
                on: { click: _vm.submit },
              },
              [_vm._v(" " + _vm._s(_vm.$t("btns.save")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }